import { useQuery } from "@apollo/client";
import { useFormikContext } from "formik";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { GET_LOYALTY_COUNTRIES_WITH_AREAS } from "@api/queriesV2/profile";
import BirthDateField from "@components/BirthDateField/BirthDateField";
import Radio from "@ui-kit/Radio/Radio";
import Select from "@ui-kit/Select/Select";
import SelectOption from "@ui-kit/Select/SelectOption";

import s from "./RegistrationProfileFields.module.scss";

const RegistrationProfileFields = ({ disabled }) => {
  const { locale } = useRouter();
  const { t } = useTranslation();
  const {
    values,
    handleChange,
    handleBlur,
    setValues,
    setFieldValue,
  } = useFormikContext();
  const { data, loading, error } = useQuery(GET_LOYALTY_COUNTRIES_WITH_AREAS, {
    context: { clientName: "v2" },
    variables: { language: locale },
    fetchPolicy: "cache-and-network",
    ssr: false,
  });
  const locations = data?.loyaltyCountriesWithAreas;
  const countries = locations?.countries || [];
  const locationsAvailable =
    !loading &&
    !error &&
    locations?.available &&
    !locations?.errorCode &&
    countries.length > 0;
  const selectedCountry = countries.find(
    (country) => String(country.countryId) === values.country,
  );
  const cities = selectedCountry?.areas || [];

  return (
    <>
      <fieldset className={s.gender} disabled={disabled}>
        <legend>{t("gender")}</legend>
        <div className={s.radios}>
          <Radio
            name="gender"
            value={t("male")}
            checked={values.gender === "SEX.MALE"}
            onChange={() => setFieldValue("gender", "SEX.MALE")}
            onBlur={handleBlur}
            disabled={disabled}
          />
          <Radio
            name="gender"
            value={t("female")}
            checked={values.gender === "SEX.FEMALE"}
            onChange={() => setFieldValue("gender", "SEX.FEMALE")}
            onBlur={handleBlur}
            disabled={disabled}
          />
        </div>
      </fieldset>
      <Select
        name="country"
        label={t("profile.country")}
        value={values.country}
        disabled={disabled || !locationsAvailable}
        onChange={(event) => {
          const country = event.target.value;
          setValues((currentValues) => ({
            ...currentValues,
            country,
            city: "",
          }));
        }}
        onBlur={handleBlur}
        errors={
          !loading && !locationsAvailable
            ? t("profile.locations unavailable")
            : undefined
        }
      >
        <SelectOption value="" text={t("profile.select country")} />
        {countries.map((country) => (
          <SelectOption
            key={country.countryId}
            value={country.countryId}
            text={country.name}
          />
        ))}
      </Select>
      {cities.length > 0 && (
        <Select
          name="city"
          label={t("profile.city")}
          value={values.city}
          disabled={disabled || !locationsAvailable}
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <SelectOption value="" text={t("profile.select city")} />
          {cities.map((city) => (
            <SelectOption key={city.areaId} value={city.areaId} text={city.name} />
          ))}
        </Select>
      )}
      <BirthDateField disabled={disabled} />
    </>
  );
};

export default RegistrationProfileFields;
